<lex-doc-viewer-context-panel-template>
    <div context-body>
        <mat-tree [dataSource]="emailFamilyDataSource" [treeControl]="emailFamilyTreeControl">
            <!-- This is the tree node template for leaf nodes -->
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding [ngClass]="{'active': node.docId === currentDocumentSnapshot.docId}">
                <lex-doc-node [node]="toDocContext(node)" [isSelected]="node.docId === currentDocumentSnapshot.docId" (click)="loadDocument(node.docId)" style="cursor:pointer;overflow:auto;"
                [ngStyle]="{'padding-left': isSingleNode ? '16px' : '0'}"></lex-doc-node>
            </mat-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-tree-node *matTreeNodeDef="let node; when: emailFamilyHasChild" matTreeNodePadding [ngClass]="{'active': node.docId === currentDocumentSnapshot.docId}">
                <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;
                  width: 100%;">
                  <lex-doc-node [node]="toDocContext(node)" [isSelected]="node.docId === currentDocumentSnapshot.docId" (click)="loadDocument(node.docId)" style="cursor:pointer;padding-left: 16px;overflow:auto;"></lex-doc-node>
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                        <i class="fa-duotone"
                            [ngClass]="{'fa-caret-left': !emailFamilyTreeControl.isExpanded(node), 'fa-caret-down': emailFamilyTreeControl.isExpanded(node)}"></i>
                    </button>
                </div>
            </mat-tree-node>
        </mat-tree>
    </div>
</lex-doc-viewer-context-panel-template>